import React from 'react';
import { Modal } from '../../';
import { Button } from '../../../components';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import './WarningModal.scss';

export const WarningModal = ({ children, open, onOk, onCancel }) => {
    return (
        <Modal
            className="warning-modal"
            title={
                <div className="warning-modal-header">
                    <ExclamationCircleOutlined className="warning-modal-icon" />
                    <span>Notice</span>
                </div>
            }
            open={open}
            okText="OK"
            closable={false}
            maskClosable={false}
            footer={[
                ...(onCancel
                    ? [
                          <Button key="cancel" shape="round" onClick={onCancel}>
                              Cancel
                          </Button>,
                      ]
                    : []),
                <Button key="ok" shape="round" type="primary" onClick={onOk}>
                    OK
                </Button>,
            ]}
        >
            {children}
        </Modal>
    );
};
